// store/reducers/user.reducer.ts
import { createReducer, on } from '@ngrx/store';
import * as SiteActions from '../actions/site.actions';
import { Site } from 'src/app/core/models/site.model';

export interface SitesState {
  sites: Site[];
  isLoading: boolean;
  hasError: boolean;
}

const initialState: SitesState = {
  sites: [],
  isLoading: false,
  hasError: false
};
export interface TypeState {
  typeSite: string;
}

const initialStateType: TypeState = {
  typeSite: ''
};

export interface TypesState {
  typesSite: string[];
}

const initialStateTypes: TypesState = {
  typesSite: []
};

export interface SiteState {
  site: Site;
}

const initialStateSite: SiteState = {
  site: {
    siteId: '',
    code: '',
    name: '',
    parkingType: '',
    createdAt: '',
    updatedAt: '',
    entrancesCount: 0,
    exitsCount: 0,
    long: '',
    lat: '',
    logoUrl: '',
    country: '',
    workingHours: {
      active: false,
      start: null,
      end: null
    },
    gymAreaConfig: {
      hoursPerVisit: null,
      FreeVisitsCount: null
    },
    notifications: {
      gatesActivity: {
        active: false,
        emails: []
      },
      cashierShiftReport: {
        active: false,
        emails: []
      },
      blacklistedCarsReport: {
        active: false,
        emails: []
      }
    },
    registeredServices: {
      public: false,
      vip: false,
      gym: false,
      reserved: false,
      openReserved: false,
      community:false
    },
    blacklistConfig: {
      action: ''
    },
    validationReasons: [],
    closeOpenTransactions: false,
    paymentMethods: []
  },
};
export const sitesReducer = createReducer(
  initialState,
  on(SiteActions.loadSitesTypeSuccess, (state, { sites }) => ({
    ...state,
    sites,
  })),
  on(SiteActions.addSiteSuccess, (state, { site }) => {
    // Filter out 'all' site temporarily
    const sitesWithoutAll = state.sites.filter(s => s.siteId !== 'all');
    // Add the new site and preserve 'all' site at the beginning
    const allSite = state.sites.find(s => s.siteId === 'all');
    const updatedSites = allSite ? [allSite, ...sitesWithoutAll, site] : [...sitesWithoutAll, site];
    
    return {
      ...state,
      sites: updatedSites,
      isLoading: false,
      hasError: false
    };
  }),
  on(SiteActions.editSiteSuccess, (state, { site }) => {
    // Update the site while preserving the 'all' site position
    const updatedSites = state.sites.map(s => s.siteId === site.siteId ? site : s);
    
    return {
      ...state,
      sites: updatedSites,
      isLoading: false,
      hasError: false
    };
  }),
  on(SiteActions.updateSiteLogoSuccess, (state, { siteId, logoUrl }) => ({
    ...state,
    sites: state.sites.map(site => 
      site.siteId === siteId ? { ...site, logoUrl } : site
    )
  }))
);

export const siteReducer = createReducer(
  initialStateSite,
  on(SiteActions.loadSiteSuccess, (state, { site }) => ({
    ...state,
    site,
  })),
  on(SiteActions.editSiteSuccess, (state, { site }) => ({
    ...state,
    site: state.site.siteId === site.siteId ? site : state.site,
  })),
  on(SiteActions.updateSiteLogoSuccess, (state, { siteId, logoUrl }) => ({
    ...state,
    site: state.site.siteId === siteId ? { ...state.site, logoUrl } : state.site,
  }))
);

export const typesReducer = createReducer(
  initialStateTypes,
  on(SiteActions.loadSiteTypesSuccess, (state, { typesSite }) => ({
    ...state,
    typesSite,
  }))
);

export const typeReducer = createReducer(
  initialStateType,
  on(SiteActions.loadSiteTypeSuccess, (state, { typeSite }) => ({
    ...state,
    typeSite,
  }))
);